const VIEWED_SPRING_FOUR_RESOURCES = 'VIEWED_SPRING_FOUR_RESOURCES'
const REQUEST_START_BLOCKED = "REQUEST_START_BLOCKED"

export default {
	VIEWED_SPRING_FOUR_RESOURCES,
	REQUEST_START_BLOCKED
}
